// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"135":"af97c423","254":"62493810","577":"ba2e82f0","761":"d5d014e4"}[chunkId] + ".chunk.js";
};